<template>
  <section id="introduction" class="intro">
    <div class="intro-top">
      <img class="intro-top-image" :src="styleImgCable" />
      <div :class="['intro-top-text', 'content-padder']">
        <h1 class="intro-top-text-headline">
          <i18n path="introduction_header">
            <Copyright />
          </i18n>
        </h1>
        <p class="intro-top-text-subheadline">
          <i18n path="introduction_paragraph">
            <Copyright />
          </i18n>
        </p>
      </div>
    </div>
    <div id="product" :class="['intro-listSection', 'content-padder']">
      <h2 class="intro-listSection-headline">
        {{ $t("introduction_list_header") }}
      </h2>
      <ListWithArrows
        :entriesLeft="listEntriesLeft"
        :entriesRight="listEntriesRight"
        flavor="black"
      />
      <!-- <DownloadButton title="downloads_intro" :downloadItems="donwloadItems" /> -->
    </div> -->
    <div :style="styleImgSurgeon" class="intro-bottomimage">
      <div class="intro-bottomimage-overlay" />
      <div :class="['intro-bottomimage-overlaycontent', 'content-padder']">
        <div>
          <MultiImage
            name="img_beam_forms"
            class="intro-bottomimage-overlaycontent-image"
          />
          <div class="intro-bottomimage-overlaycontent-caption">
            {{ $t("introduction_beam_forms") }}
          </div>
        </div>
        <div>
          <MultiImage
            name="img_membrane_filter"
            class="intro-bottomimage-overlaycontent-image"
          />
          <div class="intro-bottomimage-overlaycontent-caption">
            {{ $t("introduction_filter_membrane") }}
          </div>
        </div>
      </div>
      <div :class="['intro-bottomimage-downArrows', 'content-padder']">
        <FlippingMultiImage
          name="img_arrow_down"
          @click="cardOneOpen = !cardOneOpen"
          class="intro-bottomimage-downArrows-arrow"
        />
        <FlippingMultiImage
          name="img_arrow_down"
          @click="cardTwoOpen = !cardTwoOpen"
          class="intro-bottomimage-downArrows-arrow"
        />
      </div>
      <div
        :class="['intro-bottomimage-cardscontainer', 'content-padder']"
        v-show="cardOneOpen || cardTwoOpen"
      >
        <div class="intro-bottomimage-cardscontainer-card">
          <div
            v-show="cardOneOpen"
            class="intro-bottomimage-cardscontainer-card-content"
          >
            <MultiImage name="img_fiapc_probes" />
            <i18n path="introduction_card_left">
              <Copyright />
            </i18n>
          </div>
        </div>
        <div class="intro-bottomimage-cardscontainer-card">
          <div
            v-show="cardTwoOpen"
            class="intro-bottomimage-cardscontainer-card-content"
          >
            <i18n path="introduction_card_right">
              <br />
            </i18n>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Copyright from "@/components/Symbols/Copyright";
import MultiImage from "@/components/MultiImage";
import FlippingMultiImage from "@/components/FlippingMultiImage";
import DownloadButton from "@/components/DownloadButton";
import ListWithArrows from "@/components/ListWithArrows";

export default {
  name: "IntroductionSction",
  data: function () {
    return {
      cardOneOpen: false,
      cardTwoOpen: false,
      downloadOpen: false,
      listEntriesLeft: ["introduction_li1", "introduction_li2"],
      listEntriesRight: ["introduction_li3", "introduction_li4"],
      donwloadItems: [
        {
          previewImgName: "img_pdf_preview_sterile",
          title: "doc_title_sterile",
          file: "doc_sterile_probe",
        },
      ],
    };
  },
  components: {
    Copyright,
    MultiImage,
    FlippingMultiImage,
    DownloadButton,
    ListWithArrows,
  },
  computed: {
    styleImgCable() {
      return this.$store.getters.img_introduction_cable;
    },
    styleImgSurgeon() {
      return `background-image: url(${this.$store.getters.img_surgeon_wide})`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss";
.intro {
  width: 100%;
  overflow: hidden;
  margin-top: $navBarHeight;
  text-align: center;
  @include breakpoint(xs) {
    margin-top: $navBarHeightXS;
  }
  @include breakpoint(s) {
    margin-top: $navBarHeightS;
  }

  &-top {
    position: relative;
    height: 900px;
    display: flex;
    flex-direction: column;
    @media (max-width: 1500px) {
      height: 800px;
    }
    @media (max-width: 1280px) {
      height: 600px;
    }
    @media (max-width: 950px) {
      height: 500px;
    }
    @media (max-width: 768px) {
      height: 350px;
    }
    @media (max-width: 550px) {
      height: 300px;
    }
    &-image {
      align-self: center;
      width: 1920px;
      margin-top: -300px;
      @media (max-width: 1500px) {
        width: 1500px;
        margin-top: -110px;
      }
      @media (max-width: 1280px) {
        width: 1280px;
        margin-top: -180px;
      }
      @media (max-width: 950px) {
        width: 950px;
        margin-top: -90px;
      }
      @media (max-width: 768px) {
        width: 768px;
        margin-top: -130px;
      }
      @media (max-width: 550px) {
        width: 550px;
        margin-top: -40px;
      }
      @media (max-width: 450px) {
        width: 450px;
        margin-top: 0px;
      }
    }
    &-text {
      position: absolute;
      top: 0;
      left: 0;
      padding-top: 40px;
      @include breakpoint(xs) {
        padding-top: 10px;
      }
      @include breakpoint(s) {
        padding-top: 20px;
      }
      &-headline {
        @include ts-section-headline();
        margin-bottom: 20px;
        @include breakpoint(s) {
          margin-bottom: 15px;
        }
        @include breakpoint(xs) {
          margin-bottom: 10px;
        }
      }
      &-subheadline {
        @include ts-section-subheadline();
        color: $text_dark;
      }
    }
  }
  &-listSection {
    position: relative;
    background-color: $background-medium;

    @include breakpoint(xs) {
      padding: 0 5vw;
    }
    &-headline {
      @include ts-block-headline();
      padding: 30px 0;
      margin: auto;
    }
  }
  &-bottomimage {
    background-repeat: no-repeat;
    background-size: 120%;
    background-position: center 0%;
    position: relative;
    @include breakpoint(xs) {
      background-size: 140%;
    }
    @media screen and (max-width: 281px) {
      background-size: 180%;
    }
    @include breakpoint(s) {
      background-size: 100%;
    }

    &-overlay,
    &-overlaycontent {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 500px;
      @include breakpoint(xs) {
        height: 197px;
      }
      @include breakpoint(s) {
        height: 305px;
      }
      &-image {
        height: 369px;
        @include breakpoint(xs) {
          height: 120px;
        }
        @include breakpoint(s) {
          height: 200px;
        }
      }
    }

    &-overlay {
      background-color: $background-medium;
      mix-blend-mode: multiply;
      @include ie_or_edge() {
        background-color: rgba(177, 222, 210, 0.6);
      }
    }
    &-overlaycontent {
      @include flex-h(space-around, flex-start);
      padding-top: 30px;
      &-caption {
        @include ts-image-caption();
        padding: 15px 0;
      }
    }
    &-downArrows {
      @include flex-h(space-around, flex-start);
      padding-top: 500px + 25px;
      padding-bottom: 40px;
      @include breakpoint(xs) {
        padding-top: 197px + 15px;
        padding-bottom: 15px;
      }
      @include breakpoint(s) {
        padding-top: 305px + 30px;
        padding-bottom: 40px;
      }
      &-arrow {
        cursor: pointer;
        height: 65px;
        @include breakpoint(xs) {
          height: 36px;
        }
        @include breakpoint(s) {
          height: 40px;
        }
      }
    }
    &-cardscontainer {
      @include flex-h(space-around, center);
      padding-bottom: 40px;
      @include breakpoint(xs) {
        padding-bottom: 15px;
      }
      @include breakpoint(s) {
        padding-bottom: 40px;
      }

      &-card {
        width: 455px;
        align-self: stretch;
        @include breakpoint(xs) {
          width: 160px;
        }
        @include breakpoint(s) {
          width: 230px;
        }
        &-content {
          img {
            width: 100%;
          }
          text-align: left;
          @include ts-card-text();
          background-color: white;
          @include margin-h(10px);
          border-radius: 30px;
          padding: 43px;
          @include breakpoint(xs) {
            padding: 15px;
            border-radius: 15px;
          }
          @include breakpoint(s) {
            padding: 15px;
            border-radius: 15px;
            width: 230px;
          }
        }
      }
    }
  }
}
</style>
